import PropTypes from "prop-types";
import style from "./styles";
import CrownIcon from "../../assets/crown.svg";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";
import getMyAccountReturnsUrl from "../../utils/getMyAccountReturnsUrl";

const PremierReturnRateBanner = ({ highReturner }) => {
  const translate = useTranslate(useLocaleProvider());

  if (!highReturner) {
    return null;
  }

  return (
    <div className={style.banner} role="alert">
      <div className={style.inner}>
        <span className={style.badge}>
          <CrownIcon className={style.icon} aria-hidden="true" />
        </span>
        <div className={style.content}>
          <p className={style.title}>
            {translate("premier_returns_rate_status_message")}
          </p>
          <p className={style.message}>
            {translate("premier_returns_rate_status_description")}
          </p>
          <a
            className={style.link}
            href={getMyAccountReturnsUrl()}
            target="_top"
          >
            {translate("premier_returns_rate_learn_more")}
          </a>
        </div>
      </div>
    </div>
  );
};

PremierReturnRateBanner.propTypes = {
  highReturner: PropTypes.bool,
};

export default PremierReturnRateBanner;
